/* eslint-disable import/first */
import React, { useState, useContext, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useLocation, useNavigate } from '@reach/router';
import { Context } from '../../components/Multi-lang/Wrapper';
const { selectAllMain } = Slices.categorySlice;
import { useIntl } from 'react-intl';
import { List, ListItem, ListItemIcon, ListItemText, Grid } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import { MdPhone } from '@react-icons/all-files/md/MdPhone';
const { selectDesktop } = Slices.appSlice;
import css from './index.module.scss';
import { menuItemClickGA } from 'spwa-ui-library/esm/utils/helperGA';
import { localizePath } from 'spwa-ui-library/esm/utils/helper';
const { fetchProductsByCategoryId } = Slices.productSlice;
const { getClusterId } = Slices.configSlice;
export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));

const SideMenuRouteCard = ({ navList, setMenuClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clusterId = useSelector(getClusterId);
  const intl = useIntl();
  const profile = useSelector((state) => state.profile);
  const categories = useSelector(selectAllMain);
  const context = useContext(Context);
  const [exploreLink, setExploreLink] = useState(null);
  const countryName = profile?.country;
  const config = useSelector((state) => state.config);
  const contrySpecificValidation = config?.data?.data?.contrySpecificValidation;
  const [path, setPath] = useState('');
  const isDesktop = useSelector(selectDesktop);
  const location = useLocation();
  useEffect(() => {
    const result = categories?.sort((a, b) => a.position - b.position);
    if (result[0]?.name) {
      const exploreMenuPath = `/${URLEncode(result[0]?.name)}/${result[0]?.id}`;
      setExploreLink(exploreMenuPath);
    } else {
      setExploreLink('/home');
    }
    const isExist = contrySpecificValidation?.findIndex(({ country }) => country === countryName);
    // eslint:fix 'tel:' + ' ' is replaced by 'tel: '
    const path = 'tel: ' + contrySpecificValidation?.[isExist].customerCare;
    if (!isDesktop) {
      setPath(path);
    } else {
      setPath(`/${intl.locale}/contactUs`);
    }
  }, [
    categories,
    context.locale,
    contrySpecificValidation,
    countryName,
    exploreLink,
    intl.locale,
    isDesktop,
    path,
  ]);
  const menuItemClick = (event, path, name, titleId, state) => {
    event.preventDefault();
    if (setMenuClose) {
      setMenuClose();
    }

    const pathSplit = path.split('/');
    if (pathSplit?.length == 3) {
      dispatch(
        fetchProductsByCategoryId({
          id: pathSplit[2],
          cluster: clusterId,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      );
    }

    if (state) {
      navigate(`/${intl.locale}${path}`, {
        state: {
          oldLocation: JSON.parse(JSON.stringify(location)),
          titleId: titleId,
        },
      });
    } else {
      navigate(`/${intl.locale}${path}`);
    }
    menuItemClickGA(name);
  };
  const getURLForItem = (path) => {
    return path && localizePath(path, intl.locale);
  };
  const handlePath = (e) => {
    if (isDesktop) {
      e.preventDefault();
      navigate(path);
    }
  };
  return (
    <>
      <List className={css.root}>
        {navList.map((itemList, i) => {
          return (
            <Grid key={i}>
              {itemList.id === 'callSupport' ? (
                <a href={path} onClick={handlePath}>
                  <ListItem
                    button
                    key={itemList.name}
                    className={!itemList.icon ? css.listItem : css.liNoIcon}
                  >
                    {/* <a href=""> */}
                    <ListItemIcon className={css.iconImage}>
                      <Grid className={css.circleArea2}>
                        <MdPhone />
                      </Grid>
                    </ListItemIcon>
                    <ListItemText className={css.supportLink}>{itemList.name}</ListItemText>
                    {/* </a> */}
                  </ListItem>
                </a>
              ) : (
                <ListItem
                  button
                  component={Link}
                  href={getURLForItem(
                    itemList.id === 'exploreMenu' || itemList.id === 'greatDeals'
                      ? exploreLink
                      : itemList.urlLink
                  )}
                  key={itemList.name}
                  className={!itemList.icon ? css.listItem : css.liNoIcon}
                  onClick={(event) =>
                    menuItemClick(
                      event,
                      itemList.id === 'exploreMenu' || itemList.id === 'greatDeals'
                        ? exploreLink
                        : itemList.urlLink,
                      itemList.name.props.defaultMessage,
                      itemList.titleId,
                      itemList.state
                    )
                  }
                >
                  {itemList.icon && (
                    <ListItemIcon className={css.iconImage}>
                      <itemList.icon className={css.iconDimension} />
                    </ListItemIcon>
                  )}

                  <ListItemText className={css.staticLink} primary={itemList.name} />
                </ListItem>
              )}
            </Grid>
          );
        })}
      </List>
    </>
  );
};

export default SideMenuRouteCard;
